import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import { readableNumber } from '@attain-apps/string-utils'

/** Number component displaying different formats of numbers  */
@ngCore.Component({
  selector: 'atn-number-content',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /**
   * Value to transform into the {@link readableNumberSg} which is to be
   * displayed on the UI
   */
  public readonly valueSg = ngCore.input<
    ents.core.common.value.Raw | undefined
  >(undefined, {
    alias: 'value',
  })

  /** Value info neede to calculate the {@link readableNumberSg} */
  public readonly valueInfoSg = ngCore.input<
    ents.core.common.value.Info | undefined
  >(undefined, {
    alias: 'valueInfo',
  })

  /**
   * Formatted value to display in the template
   */
  public readonly readableNumberSg = ngCore.computed(
    (value = this.valueSg(), valueInfo = this.valueInfoSg()) => {
      // Nothing we can do at this point, just return undefined
      if (value === undefined || typeof value !== 'number') {
        return undefined
      }

      const valueType =
        valueInfo?.type ??
        ents.core.common.value.types.Intrinsic.inferFrom(value)

      // If we we're able to determine a type, we can use to get the
      // readableNumber preset
      const preset =
        ents.core.common.value.types.Intrinsic.ForNumber.isForNumber(valueType)
          ? ents.core.common.value.types.Intrinsic.ForNumber.toReadableNumberPreset(
              valueType,
            )
          : undefined

      // If we don't have preset, we at least want to display something
      return readableNumber(value, preset ?? { decimals: valueInfo?.precision })
    },
  )
}
